import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Initial state
const initialState = {
  page: null,
  data: null,
  error: false,
  loading: false,
  loaded: false,
  status: null,
  dsetination: null,
  errorType: null,
  unavailableCount: 0,
};

// Slice
const getSendbirdStatusSlice = createSlice({
  name: "getSendbirdStatus",
  initialState,
  reducers: {
    fetchDataStart(state) {
      return { ...state, loading: true, error: false, loaded: false };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
    setStatus(state, action) {
      const { status, errorType, unavailableCount } = action.payload;
      return {
        ...state,
        status,
        errorType,
        unavailableCount,
      };
    },
    initUnavailableCount(state) {
      return {
        ...state,
        unavailableCount: 0,
        status: null,
        errorType: null,
      };
    },
  },
});

export const { fetchDataStart, fetchDataSuccess, fetchDataFailure, setStatus, initUnavailableCount } =
  getSendbirdStatusSlice.actions;

export default getSendbirdStatusSlice.reducer;

//saga
function* fetchDataSaga(action) {
  const unavailableCount = yield select((state) => state.getSendbirdStatus.unavailableCount);
  const peerIp = yield select((state) => state.peerIp.ip);

  try {
    const { headers = {}, apiUrl } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      },
    });
    const response = yield call(apiService.get, apiUrl); // sendbird 상태 확인
    yield put(fetchDataSuccess(response.data));

    const data = yield select((state) => state.getSendbirdStatus.data);
    const firstdata = data?.data[0];
    const [count, is_running] = [firstdata.count, firstdata.is_running];
    const page = yield select((state) => state.getSendbirdStatus.page);

    if (count >= 30 && !is_running) {
      yield put(setStatus({ status: "unavailable", errorType: "장애페이지 04-01", unavailableCount: unavailableCount + 1 }));
    } else {
      yield put(setStatus({ status: "available", unavailableCount: 0 }));
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
    yield put(setStatus({ status: "unavailable", errorType: "장애페이지 04-02", unavailableCount: unavailableCount + 1 }));
  }
}

// API 호출을 감시하는 Saga 함수
export function* getSendbirdStatusSaga() {
  yield takeLatest(fetchDataStart.type, fetchDataSaga);
}
